import createBreakpoints from "@mui/system/createTheme/createBreakpoints";

const breakpoints = createBreakpoints({})

const MuiTypography = {
  h1: {
    fontSize: 40,
    fontFamily: 'PreloSlab',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    color: '#1b2d54',
    [breakpoints.down('sm')]: {
      fontSize: 32
    }
  },
  h2: {
    fontSize: 32,
    fontFamily: 'PreloSlab',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    lineHeight: '38px',
    [breakpoints.down('sm')]: {
      fontSize: 28
    }
  },
  h3: {
    fontFamily: 'PreloSlab',
    fontSize: 28,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    [breakpoints.down('sm')]: {
      fontSize: 24
    } 
  },
  h4: {
    fontFamily: 'PreloSlab',
    fontSize: 24,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    [breakpoints.down('sm')]: {
      fontSize: 22
    } 
  },
  h5: {
    fontFamily: 'Prelo',
    fontSize: 20,
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',

  },
  h6: {
    fontFamily: 'Prelo',
    fontSize: 18,
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    color: '#4a4a4a',

  },
  subtitle1: {
    fontFamily: 'Prelo',
    fontSize: 16,
    fontWeight: 600,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal'
  },
  body1: {
    fontFamily: 'Prelo',
    fontSize: 16,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    color: '#4a4a4a',
    [breakpoints.down('sm')]: {
      fontSize: 14
    } 
  },
  body2: {
    fontSize: 14,
    fontFamily: 'Prelo',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    lineHeight: '1.6',
    [breakpoints.down('sm')]: {
      fontSize: 12
    } 
  },
  caption: {
    fontFamily: 'Prelo',
    fontSize: 12,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    color: '#4a4a4a',

  },
  subtitle2: {
    fontFamily: 'Prelo',
    fontSize: 12,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    [breakpoints.down('sm')]: {
      fontSize: '10px '
    }
  },
}

export default MuiTypography
